// 拷贝参考-待验证修改

import { getSignature, login } from "@/api/auth";
import store from "@/store";
import router from "@/router";
import { getQueryString } from "@/utils";

const wx = window.wx;
const jsApiList = [
  "getCurExternalContact",
  "sendChatMessage",
  "getContext",
  "openUserProfile",
  "getCurExternalChat",
  "openExistedChatWithMsg",
  "navigateToAddCustomer",
  "checkJsApi",
];
// 接口获取微信注入参数
async function getConfigParam(corpId, agentId, type) {
  try {
    const data = {
      appId: agentId,
      cached: true,
      corpId,
      tenantId: store.getters.tenantId,
      type,
      url: window.location.href.split("#")[0],
    };
    const { result } = await getSignature(data);
    console.log("getConfigParam1", result);
    return result;
  } catch (e) {
    console.log(e);
  }
}
// wx.config
export function wxConfig(corpId, agentId) {
  return new Promise((resolve, reject) => {
    getConfigParam(corpId, agentId, 1)
      .then((data) => {
        console.log("wxConfig2", data);
        const { timestamp, nonceStr, signature } = data;
        wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: corpId, // 必填，企业微信的corpID
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList, // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
        wx.ready(async function () {
          resolve();
        });
        wx.error((res) => {
          console.log("wxConfig", res);
          reject(res);
        });
      })
      .catch((e) => {
        reject(e);
      });
  });
}
// wx.agentConfig
export function agentConfig(corpId, agentId) {
  return new Promise((resolve, reject) => {
    getConfigParam(corpId, agentId, 2)
      .then((data) => {
        console.log("agentConfig3", data);
        const { corpId, timestamp, nonceStr, signature } = data;
        wx.agentConfig({
          corpid: corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList,
          success: function (res) {
            resolve(res);
          },
          fail: (res) => {
            this.$alert("wx.agentConfig fail");
            reject("agentConfig", res);
            if (res.errMsg.indexOf("function not exist") > -1) {
              this.$alert("版本过低请升级");
            }
          },
        });
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export async function getConfigParams(corpId, agentId, type) {
  try {
    const data = {
      appId: agentId,
      cached: true,
      corpId,
      tenantId: store.getters.tenantId,
      type,
      url: window.location.href.split("#")[0],
    };
    const { result } = await getSignature(data);
    console.log("getConfigParam1", result);
    return result;
  } catch (e) {
    console.log(e);
  }
}

// 授权获取code
export function auth(corpId, agentId) {
  return new Promise(async (resolve, reject) => {
    console.log(console.log(router.app["_route"], "当前href", location.href));

    const userInfo = localStorage.getItem("userInfo");
    if (!userInfo || "" + userInfo === "undefined") {
      if (location.href.indexOf("code") == -1) {
        // 跳拼接的授权地址
        return (location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${location.href}&response_type=code&scope=snsapi_base&agentid=${agentId}#wechat_redirect`);
      } else {
        // 缓存和重定向
        console.log("缓存和重定向");
        const route = router.app["_route"];
        // 设置vuex信息(登录授权后重新加载属于初始在login页面)
        if (route.params.corpId)
          store.commit("SET_CORPID", route.params.corpId);
        if (route.params.tenantId)
          store.commit("SET_TENANTID", route.params.tenantId);
        if (route.params.agentId)
          store.commit("SET_AGENTID", route.params.agentId);
        console.log(
          "auth设置企微信息：",
          "corpId:",
          store.getters.corpId,
          "agentId:",
          store.getters.agentId
        );
        // 登录并跳重定向地址
        await loginM(route.params.corpId, route.params.agentId);
      }
    }
    resolve();
  });
}

export function loginM(corpId, agentId) {
  console.log("进入登录接口", corpId, agentId);
  return new Promise((resolve, reject) => {
    login({
      appId: agentId,
      code: getQueryString("code"),
      corpId,
      tenantId: store.getters.tenantId,
    }).then((res) => {
      console.log("登录后:", res.result);
      // 缓存用户信息
      if (res.result) {
        const userInfo = res.result;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        store.commit("SET_USERINFO", userInfo);
      }
      // 刷新重新激活登录页生命周期
      // location.reload()
      resolve();
    });
  });
}

// 初始校验是否已获取配置
export function initAgentConfig() {
  return new Promise(async (resolve, reject) => {
    console.log("getters", store.getters.initAgentConfig);
    if (store.getters.initAgentConfig) {
      return resolve();
    }
    const route = router.app["_route"];
    let agentId =
      getQueryString("agentId") ||
      store.getters.agentId ||
      route.params.agentId;
    let corpId =
      getQueryString("corpId") || store.getters.corpId || route.params.corpId;
    console.log(123, agentId, corpId);

    if (!agentId || !corpId) {
      let userInfo = localStorage.getItem("userInfo");
      if (!userInfo) return reject("缺少userInfo");

      userInfo = JSON.parse(userInfo);
      agentId = store.getters.agentId;
      corpId = store.getters.corpId;
    }

    if (!agentId || !corpId) {
      return reject();
    }

    // 从企业微信3.0.24及以后版本（可通过企业微信UA判断版本号），无须先调用wx.config，可直接wx.agentConfig.
    const res1 = await wxConfig(corpId, agentId);
    const res2 = await agentConfig(corpId, agentId);
    console.log("wxConfig and agentConfig Success", res1, res2);
    store.commit("SET_INIT_AGENT_CONFIG", true);
    resolve();
  });
}

export async function getContext(retry) {
  await initAgentConfig();
  return new Promise((resolve, reject) => {
    wx.invoke("getContext", {}, async function (res) {
      if (res.err_msg === "getContext:ok") {
        const entry = res.entry; // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools
        resolve(entry);
      } else {
        if (retry !== true) {
          store.commit("SET_INIT_AGENT_CONFIG", false);
          resolve(await getContext(true));
        } else {
          // 错误处理
          reject(res.err_msg);
        }
      }
    });
  });
}
// 获取当前对话客户微信userId
export async function getCurExternalContact(retry) {
  await initAgentConfig();
  return new Promise((resolve, reject) => {
    wx.invoke("getCurExternalContact", {}, async function (res) {
      if (res.err_msg === "getCurExternalContact:ok") {
        const userId = res.userId; // 返回当前外部联系人userId
        // commit('SET_WX_USER_ID', userId)
        resolve(userId);
      } else {
        if (retry !== true) {
          store.commit("SET_INIT_AGENT_CONFIG", false);
          resolve(await getCurExternalContact(true));
        } else {
          // 错误处理
          reject(res.err_msg);
        }
      }
    });
  });
}

export async function sendChatMessage(type, content, retry) {
  // 1 文本 2 图片 3 图文 5 视频 7文件
  let param;
  switch (type) {
    case 1:
      param = {
        msgtype: "text",
        text: {
          content,
        },
      };
      break;
    case 2:
      param = {
        msgtype: "image",
        image: {
          mediaid: content,
        },
      };
      break;
    case 3:
      param = {
        msgtype: "news",
        news: content,
      };
      break;
    case 5:
      param = {
        msgtype: "video",
        video: {
          mediaid: content,
        },
      };
      break;
    case 7:
      param = {
        msgtype: "file",
        file: {
          mediaid: content,
        },
      };
      break;
  }
  await initAgentConfig();
  return new Promise((resolve, reject) => {
    wx.invoke("sendChatMessage", param, async function (res) {
      if (res.err_msg === "sendChatMessage:ok") {
        // 发送成功
        resolve();
      } else {
        if (retry !== true) {
          store.commit("SET_INIT_AGENT_CONFIG", false);
          resolve(await sendChatMessage(type, content, true));
        } else {
          this.$alert(res.err_msg);
          reject(res.err_msg);
        }
      }
    });
  });
}
// getCurExternalChat
export async function openUserProfile(type, userid, retry) {
  const params = {
    type,
    userid,
  };
  await initAgentConfig();
  return new Promise((resolve, reject) => {
    wx.invoke("openUserProfile", params, async (res) => {
      if (res.err_msg === "openUserProfile:ok") {
        // const userId = res.userId // 返回当前外部联系人userId
        // resolve(userId)
      } else {
        if (retry !== true) {
          store.commit("SET_INIT_AGENT_CONFIG", false);
          await openUserProfile(type, userid, true);
        } else {
          this.$alert(res.err_msg);
          // 错误处理
          reject(res.err_msg);
        }
      }
    });
  });
}
// 获取当前客户群的群ID
export async function getCurExternalChat(retry) {
  await initAgentConfig();
  return new Promise((resolve, reject) => {
    wx.invoke("getCurExternalChat", {}, async function (res) {
      if (res.err_msg === "getCurExternalChat:ok") {
        const chatId = res.chatId; // 返回当前外部联系人userId
        resolve(chatId);
      } else {
        if (retry !== true) {
          store.commit("SET_INIT_AGENT_CONFIG", false);
          resolve(await getCurExternalChat(true));
        }
      }
    });
  });
}
// 打开当前群聊
export async function openExistedChatWithMsg(chatId, retry) {
  await initAgentConfig();
  const params = {
    chatId,
  };
  return new Promise((resolve, reject) => {
    wx.invoke("openExistedChatWithMsg", params, async function (res) {
      if (res.err_msg === "openExistedChatWithMsg:ok") {
      } else {
        if (retry !== true) {
          store.commit("SET_INIT_AGENT_CONFIG", false);
          resolve(await openExistedChatWithMsg(chatId, true));
        } else {
          this.$alert(res.errmsg);
          // 错误处理
          reject(res.errmsg);
        }
      }
    });
  });
}
// export function openEnterpriseChat (chatId) {
//   wx.openEnterpriseChat({
//     chatId,
//     success: function (res) {
//
//     },
//     fail: function (res) {
//       Toast({ position: 'top', message: res.errmsg })
//       if (res.errMsg.indexOf('function not exist') > -1) {
//         this.$alert('版本过低请升级')
//       }
//     }
//   })
// }

// 进入添加客户界面
export async function navigateToAddCustomer() {
  await initAgentConfig();
  return new Promise((resolve, reject) => {
    wx.invoke("navigateToAddCustomer", {}, function (res) {});
  });
}
